<script>
  /* eslint-disable */
  import {getBasicConfiguration, getReboques} from '../../domain/callcenter/services'
  import BtnAtendimento from './components/BtnAtendimento'
  import Atendimento from './components/Atendimento'
  import TicketsAtivos from './components/TicketsAtivos'
  import {getTickets} from '../../domain/callcenter/services'
  import printError from '../../utils/printError'
  import CallCenterMap from './components/CallCenterMap'
  import Comunicator from '../../domain/websocket/comunicator'
  import _base from '../_default/components/_base'
  
  // import http from '../../../utils/services/http'
  // import {filter} from 'uloc-vue';

  export default {
    name: 'Callcenter',
    extends: _base,
    components: {
      CallCenterMap,
      Atendimento,
      BtnAtendimento,
      TicketsAtivos
    },
    data () {
      return {
        loadingTickets: false,
        remocoes: [],
        openAtendimento: false,
        reboques: [],
        patios: [],
        categorias: [],
        agentes: []
      }
    },
    created () {
      this.$ticketLoader && clearInterval(this.$ticketLoader)
      this.getReboquesDisponiveis()
      this.getBasicConfiguration()
    },
    computed: {},
    mounted () {
      if (this.$route.query.redirect && this.$route.query.redirect === 558) {
          this.openAtendimento = true
      } else {
        console.log('não redirecionado')
      }
      this._showFooter(false)
      this._menuFolded(true)
      /* Realtime Comunicator */
      // TODO: Avisar no front ao usuário em caso de falha de conexão
      this.comunicator = Comunicator.connect(process.env.WS_REMOCAO_URL)
      /**
       * {
      headers: {
        token: http.defaults.headers.common['Authorization']
      }
    }
       */
      this.comunicator.on('localizacaoReboque', this.onLocalizacaoReboque)
      this.comunicator.on('com/connect', (env) => {
        this.isComConnected = 1
      })
      this.comunicator.on('com/disconnect', (env) => {
        this.isComConnected = 2
      })
      window.setTimeout(() => {
        if (this.isComConnected !== 1) {
          this.isComConnected = 2 // No connection alert
        }
      }, 4000)

      this.$ticketLoader && clearInterval(this.$ticketLoader)
      this.$ticketLoader = window.setInterval(() => {
        this.getTickets()
      }, 5000)
      // document.querySelector('.u-erp-layout-container').classList.add('bg-white')
    },
    destroyed () {
      this._showFooter(true)
      this.$ticketLoader && clearInterval(this.$ticketLoader)
      if (this.comunicator) {
        console.log('Saindo da tela realtime')
        this.comunicator.close()
      }

      // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
    },
    methods: {
      novoAtendimento (remocao) {
        this.remocoes.push(remocao)
      },
      atualizaAtendimento (remocao) {
        let patioDestino = remocao.patioDestino.latitude + ',' + remocao.patioDestino.longitude
        console.log(patioDestino)
        this.$refs.map.montaRotaAtendimento(remocao.id, this.$remocaoMarker.position, patioDestino)
      },
      getTickets () {
        this.loadingTickets = true
        getTickets()
          .then((response) => {
            let data = response.data
            console.log(data)
            this.loadingTickets = false
            this.remocoes = data
            if (Array.isArray(this.remocoes) && this.remocoes.length > 0) {
              this.remocoes.forEach(r => {
                if (Array.isArray(r.rotasAtivas) && r.rotasAtivas.length > 0) {
                  r.rotasAtivas.forEach(route => {
                    this.$refs.map.renderRoute(route)
                  })
                }
              })
            }
          })
          .catch((response) => {
            this.loadingTickets = false
          })
      },
      getReboquesDisponiveis () {
        getReboques()
          .then(({data}) => {
            this.reboques = data
          })
          .catch(({response}) => {
            /* this.$uloc.notify({
              color: 'negative',
              message: `Erro ao tentar carregar os reboques disponíveis "${printError(response)}"`
            }) */
            alert(`Erro ao tentar carregar os reboques disponíveis "${printError(response)}"`)
          })
      },
      getBasicConfiguration () {
        getBasicConfiguration()
          .then(({data}) => {
            this.patios = data.patios
            this.categorias = data.categorias
            this.agentes = data.agentes
            console.log(data.patios)
          })
          .catch(({response}) => {
            /* this.$uloc.notify({
              color: 'negative',
              message: `Erro ao tentar carregar as configurações básicas "${printError(response)}"`
            }) */
            alert(`Erro ao tentar carregar as configurações básicas "${printError(response)}"`)
          })
      },
      geocodeAddress (address) {
        console.log(address)
        let latLng = this.$refs.map.geocodeAddress(address)
          .then(location => {
            let mapComponent = this.$refs.map
            mapComponent.map.setCenter(location)
            this.$remocaoMarker && this.$remocaoMarker.setMap(null)
            this.$remocaoMarker && delete this.$remocaoMarker
            this.$remocaoMarker = new mapComponent.google.maps.Marker({
              map: mapComponent.map,
              position: location,
              draggable: true,
              title: 'Local da Remoção'
            })

            // console.log('ZZZXXZ', this.$remocaoMarker.position.toJSON())
            mapComponent.maxZoomService.getMaxZoomAtLatLng(location, (response) => {
              if (response.status !== 'OK') {
                mapComponent.map.setZoom(10)
              } else {
                mapComponent.map.setZoom(response.zoom)
              }
            })
            // console.log('CXXX', location)
          })
          .catch(err => {
            console.log('ERR GEOCODER ', err)
            this.$remocaoMarker && delete this.$remocaoMarker
            // this.$uloc.notify({color: 'negative', message: `Endereço não localizado no mapa`})
            alert(`Endereço não localizado no mapa`)
          })
      },
      onLocalizacaoReboque: function (data) {
        console.log('Localização Reboque: ', data)
        // TODO: Validate data
        this.$refs.map.moveReboque(data)
      }
    }
  }
</script>

<template>
  <div class="app-content h-full">
    <div class="app-content-body app-content-full" style="bottom: 0px">
      <div class="hbox hbox-auto-xs">
        <div class="layout-callcenter">
          <call-center-map ref="map" :reboques="reboques"></call-center-map>
          <btn-atendimento @click="openAtendimento = !openAtendimento"/>
          <atendimento
            :opened="openAtendimento"
            @close="openAtendimento = false"
            @novoAtendimento="novoAtendimento"
            @atualizaAtendimento="atualizaAtendimento"
            @geocodeAddress="geocodeAddress"
            :patios="patios"
            :categoria="categorias"
            :agentes="agentes"
          />
          <tickets-ativos :remocoes="remocoes"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./assets/default.scss" lang="scss"></style>




// WEBPACK FOOTER //
// Main.vue?460128df